import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {KPIGetListResponseT, KPIGetParamsT, ReportGetListResponseT, ReportT} from '../types/kpi.types'

export class KPIRepository {
    getDeliveryList(params: KPIGetParamsT): Promise<AxiosResponse<KPIGetListResponseT>> {
        return http.get('/kpi/api/delivery', { params })
    }

    getTelephonyList(params: KPIGetParamsT): Promise<AxiosResponse<KPIGetListResponseT>> {
        return http.get('/kpi/api/telephony', { params })
    }

    uploadDeliveryFile(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/kpi/api/delivery/upload`, form_data)
    }

    uploadTelephonyFile(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/kpi/api/telephony/upload`, form_data)
    }

    getReport(form_data: FormData): Promise<AxiosResponse<ReportGetListResponseT>> {
        return http.postFormData(`/kpi/api/bind`, form_data)
    }
}
